































import {Component, Mixins, Prop, Watch} from 'vue-property-decorator';
import EditDialog from '@/components/EditDialog.vue';
import EditDialogMixin from '@/mixins/EditDialogMixins';
import {PModuleType} from '@/enums/configs';
import SelectionList from '@c/controls/selectionList/SelectionList.vue';
import SimpleDialog from '@c/SimpleDialog.vue';

@Component({
  components: {
    EditDialog,
    SelectionList,
    SimpleDialog,
  },
})
export default class CleanModuleSettingsEditDialog extends Mixins(EditDialogMixin) {
  @Prop()
  pmodules!: any[];

  @Prop()
  filter!: PModuleType;

  nonEmptyTextRule = (v: any) => !!v || (v && v.length === 0) || 'Поле обязательно для заполнения';

  filteredPmodules: any[] = [];

  dialog = false;

  @Watch('pmodules')
  async onPmodulesChange(newVal: any) {
    if (!newVal.length) return;
    this.filteredPmodules = this.pmodules.filter(x => x.type == this.filter);
  }
}
